module.exports = __webpack_public_path__ + "static/media/Piercing-mascintimate-hafada.e38c9055.png";